<script lang="ts" setup>
import { ApiInsuranceAdditionalDetail } from '~~/server/api/insurance/additional/insurance/[slug]'

const route = useRoute()
const { $t } = useNuxtApp()

const { data: page, redirect } = await useFetchWithRedirect<ApiInsuranceAdditionalDetail>(
    `/api/insurance/additional/insurance/${route.params.id}`,
    { route },
    {
        params: {
            slug: route.params.id,
        },
    }
)

if(redirect && !redirect?.error) {
    navigateTo(redirect.data.url, redirect.data.options)
}

const breadcrumbs = computed<BreadcrumbsLink[]>(() => {
    if (!route.params.id) return []

    return [
        {
            name: $t('Pripoistenia'),
            slug: useNamedRoutes({ name: 'additional-insurance' }),
        },
    ]
})

usePageMeta({
    meta: page.value?.data.meta,
    title: page.value?.data.title,
})
</script>

<template>
  <article v-if="page">
    <PageMeta :data="page.data" />
    <ContainerFluid>
      <Breadcrumbs
        v-if="page.data.life_insurance"
        :current="page.data.title"
        :links="breadcrumbs"
        class="border-bottom pb-3 mb-4 mb-md-13"
      />
      <PageHeaderContent
        :tag="page.data.tag"
        :title="page.data.title"
        subtitle=""
        class="mt-12 mb-12"
        text-color="black-100"
      />
      <Tracker :data="{ position: page.data.title }">
        <PagesAdditionalInsuranceDetail :data="page.data" />
      </Tracker>
    </ContainerFluid>
  </article>
</template>
